'use client';

import { createIcon } from './utils';

import type { TSVGIcon } from './interface';

export const MenuIcon: TSVGIcon = createIcon({
  displayName: 'MenuIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M4 5a1 1 0 0 0 0 2h16a1 1 0 1 0 0-2H4Zm-1 7a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm0 6a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Z'
    />
  ),
});
